import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import SEO from "../components/SEO";

import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Link from "../components/v2/Link";
import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../components/v4/FaqSection/FaqSection";

import whatsappHeroIcon from "../images/v4/whatsappCustomerSupport/icons/whatsappHeroIcon.svg";
import greenUpArrowIcon from "../images/v4/whatsappCustomerSupport/icons/greenUpArrowIcon.svg";
import greenCheckCircle from "../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import whiteCheckIcon from "../images/v4/whatsappCustomerSupport/icons/whiteCheckIcon.svg";

import realWorldImg1 from "../images/v4/whatsappCustomerSupport/images/realWorldImg1.png";
import realWorldImg2 from "../images/v4/whatsappCustomerSupport/images/realWorldImg2.png";
import realWorldImg3 from "../images/v4/whatsappCustomerSupport/images/realWorldImg3.webp";
import realWorldImg4 from "../images/v4/whatsappCustomerSupport/images/realWorldImg4.png";
import realWorldImg5 from "../images/v4/whatsappCustomerSupport/images/realWorldImg5.png";

import clientLogo1 from "../images/v4/TgPages/marketting/clientImg/client1.png";
import clientLogo2 from "../images/v4/TgPages/marketting/clientImg/client2.png";
import clientLogo3 from "../images/v4/TgPages/marketting/clientImg/client3.png";
import clientLogo4 from "../images/v4/TgPages/marketting/clientImg/client4.png";
import clientLogo5 from "../images/v4/TgPages/marketting/clientImg/client5.png";
import clientLogo6 from "../images/v4/TgPages/marketting/clientImg/client6.png";
import clientLogo7 from "../images/v4/TgPages/marketting/clientImg/client7.png";

import growingIcon1 from "../images/v4/whatsappCustomerSupport/icons/growingIcon1.svg";
import growingIcon2 from "../images/v4/whatsappCustomerSupport/icons/growingIcon2.svg";
import growingIcon3 from "../images/v4/whatsappCustomerSupport/icons/growingIcon3.svg";
import growingIcon4 from "../images/v4/whatsappCustomerSupport/icons/growingIcon4.svg";
import growingIcon5 from "../images/v4/whatsappCustomerSupport/icons/growingIcon5.svg";

import broadcastImg1 from "../images/v4/whatsappCustomerSupport/images/broadcastImg1.webp";
import broadcastImg2 from "../images/v4/whatsappCustomerSupport/images/broadcastImg2.webp";
import broadcastImg3 from "../images/v4/whatsappCustomerSupport/images/broadcastImg3.webp";
import broadcastImg4 from "../images/v4/whatsappCustomerSupport/images/broadcastImg4.webp";

import whatsappPageHeroBg from "../images/v4/whatsappCustomerSupport/images/whatsappPageHeroBg.png";
import newSectionBackground from "../images/v4/whatsappCustomerSupport/images/newSectionBackground.png";
import whatsappPageHeroBgMobile from "../images/v4/whatsappCustomerSupport/images/whatsappPageHeroBgMobile.png";
import growingBussinessBg from "../images/v4/whatsappCustomerSupport/images/growingBussinessBg.png";
import tabsSectionBg from "../images/v4/whatsappCustomerSupport/images/tabsSectionBg.png";
import benefitSection1Bg from "../images/v4/whatsappCustomerSupport/images/benefitSection1Bg.png";
import experienceBg from "../images/v4/whatsappCustomerSupport/images/experienceBg.png";
import experienceImg from "../images/v4/whatsappCustomerSupport/images/experienceImg.png";
import boostBg from "../images/v4/whatsappCustomerSupport/images/boostBg.png";
import benifitImage1 from "../images/v4/whatsappCustomerSupport/images/benifitImage1.png";
import benifitImage2 from "../images/v4/whatsappCustomerSupport/images/benifitImage2.png";

import capabilitiesImg1 from "../images/v4/whatsappCustomerSupport/images/capabilitiesImg1.png";
import capabilitiesImg2 from "../images/v4/whatsappCustomerSupport/images/capabilitiesImg2.webp";
import capabilitiesImg3 from "../images/v4/whatsappCustomerSupport/images/capabilitiesImg3.webp";
import capabilitiesImg4 from "../images/v4/whatsappCustomerSupport/images/capabilitiesImg4.webp";
import capabilitiesImg5 from "../images/v4/whatsappCustomerSupport/images/capabilitiesImg5.webp";

import TruestedSection from "../components/v4/TrustedSection/TruestedSection";

const useStyles = makeStyles((theme) => ({
   whatsappSection: {
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundImage: `url(${whatsappPageHeroBg})`,
      padding: "60px 0",
      "& $aiSectionLeft": {
         width: "50%",
         gap: "25px",
      },
      "& .countryHighlight": {
         background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
      },
      "& .buttonContaienr": {
         marginTop: "20px",
      },
      "& .container": {
         paddingBottom: "40px",
      },

      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "80%",
         margin: "0 auto",
         textAlign: "center",
         marginTop: "70px",
      },
      "@media only screen and (max-width: 600px)": {
         paddingBottom: "400px",
         backgroundPosition: "bottom",
         backgroundRepeat: "no-repeat",
         backgroundSize: "cover",
         backgroundImage: `url(${whatsappPageHeroBgMobile})`,
         "& $aiSectionLeft": {
            width: "100%",
            gap: "16px",
            "&  .wpLogo": {
               width: "40px",
               height: "40px",
               position: "relative",
               top: "10px",
            },
         },
         paddingTop: "0px",
         "& .centerContainer": {
            width: "100%",
            marginTop: "30px",
         },
         "& .container": {
            paddingBottom: "20px",
         },
         "& .buttonContaienr": {
            marginTop: "10px",
         },
      },
   },
   aiSectionContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
      },
   },
   aiSectionLeft: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "40%",
      gap: "20px",
      "& .highlighterText": {
         background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
      },
      // "&  .wpLogo": {
      //   width: "40px",
      //   height: "40px",
      //   position: "relative",
      //   top: "10px",
      // },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   aiSectionRight: {
      width: "40%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   listContainer: {
      display: "flex",
      marginTop: "16px",
      width: "100%",
      flexWrap: "wrap",
      // flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "15px",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         minWidth: "100%",
         gap: "8px",
         marginTop: "0",
      },
   },
   listItem: {
      background: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "15px",
      border: "1px solid #00B661",
      borderRadius: "50px",
      padding: "10px 15px",
      minWidth: "max-content",
      "@media only screen and (max-width: 600px)": {},
      // color: "#A2BED3",
   },
   Client: {
      background: "#063F2E",
      padding: "0",
      "& .client-carousel": {
         backgroundSize: "contain",
         //   backgroundImage: `url(${industryadaptbg})`,
         backgroundRepeat: "no-repeat",
         backgroundPosition: "center",
      },
      "& .header": {
         display: "flex",
         width: "33%",
         gap: "10px",
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         textAlign: "left",
      },
      "& .body": {
         display: "flex",
         justifyContent: "space-between",
         alignItems: "center",
         width: "100%",
         marginTop: "50px",
      },
      "@media only screen and (max-width: 1024px)": {
         padding: "0",
         background: "#002a1e",
         "& .header": {
            width: "40%",
         },
         "& .body": {
            marginTop: "40px",
         },
      },
      "@media only screen and (max-width: 768px)": {
         padding: "0",
         "& .header": {
            width: "60%",
         },
         "& .body": {
            marginTop: "30px",
         },
      },
      "@media only screen and (max-width: 600px)": {
         padding: "0",
         "& .header": {
            width: "100%",
         },
         "& .body": {
            flexDirection: "column",
            flexWrap: "wrap",
            rowGap: "15px",
         },
      },
      "& .swiper-wrapper": {
         alignItems: "streach",
         padding: "16px 8px",
      },
   },
   clientDetails: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: "40px",
      "@media only screen and (max-width: 1024px)": {
         gap: "30px",
      },
      "@media only screen and (max-width: 768px)": {
         flexDirection: "column",
         gap: "30px",
         alignItems: "center",
      },
      "@media only screen and (max-width: 600px)": {
         gap: "20px",
         alignItems: "flex-start",
      },
      "@media only screen and (max-width: 480px)": {
         gap: "15px",
      },
      "& .header": {
         "@media only screen and (max-width: 768px)": {
            textAlign: "center",
            "& p": {
               width: "100%",
            },
         },
      },
   },
   integrationHeader: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         gap: "30px",
      },
   },
   integrationLeft: {
      width: "42%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   integrationRight: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "40%",
      gap: "20px",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   benefitSection: {
      background: "linear-gradient(180deg, #063F2E 25.37%, #002A1E 100%)",
      "& $integrationLeft": {
         width: "45%",
         display: "flex",
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         gap: "10px",
      },
      "& $integrationHeader": {
         justifyContent: "space-around",
         alignItems: "center",
      },
      "&.benefitSection0": {
         background: "#EFFFFB",
         "& $integrationHeader": {
            flexDirection: "row-reverse",
         },
      },
      "&.benefitSection1": {},
      "&.benefitSection2": {
         backgroundImage: `url(${benefitSection1Bg})`,
         backgroundPosition: "center",
         backgroundSize: "cover",
         backgroundRepeat: "no-repeat",
         // "& $integrationHeader": {
         //   flexDirection: "row-reverse",
         // },
      },
      "&.benefitSection3": {},
      "@media only screen and (max-width: 600px)": {
         background: "linear-gradient(0deg, #063F2E 25.37%, #002A1E 100%)",
         "& $integrationLeft": {
            width: "100%",
         },
         "& $integrationRight": {
            width: "100%",
         },
         "&.benefitSection0": {
            "& $integrationHeader": {
               flexDirection: "column-reverse !important",
            },
         },
         "&.benefitSection2": {
            "& $integrationHeader": {
               flexDirection: "column !important",
            },
         },
      },
   },
   pointers: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "20px",
   },
   cardPointer: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "15px",
      "& $pointerImg": {
         paddingTop: "5px",
      },
      "@media only screen and (max-width: 600px)": {
         alignItems: "center",
      },
   },
   pointerImg: {},
   growingBusiness: {
      backgroundImage: `url(${growingBussinessBg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      paddingBottom: "80px",
      position: "relative",
      "& .header": {
         width: "55%",
         display: "flex",
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         textAlign: "left",
         gap: "32px",
      },
      "& $featureContainer": {
         gap: "20px",
      },
      "@media only screen and (max-width: 600px)": {
         paddingBottom: "50px",
         "& .header": {
            width: "100%",
         },
      },
   },
   broadcastContainerInner: {
      gap: "30px",
      width: "100%",
      display: "flex",
      padding: "0 8rem 0rem 8rem",
      paddingBottom: "10px !important",
      alignItems: "stretch",
      justifyContent: "flex-start",
      "& swiper-wrapper": {
         alignItems: "stretch !important",
      },

      "& $featureContainer": {
         width: "31%",
         height: "auto  !important",
      },
      "@media only screen and (max-width: 600px)": {
         padding: "0 15px !important",
         paddingBottom: "10px !important",
      },
      "@media only screen and (min-width: 1900px)": {
         paddingLeft: "23rem !important",
         paddingRight: "23rem !important",
      },
   },
   featureContainer: {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "32%",
      gap: "22px",
      boxShadow: "0px 0px 16px #C1D7DB66",
      borderRadius: "16px",
      background: "#fff",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "& p": {
         width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "& p": {
            width: "100%",
         },
      },
   },
   cardsSection: {
      "& .centerHeader": {
         gap: "10px",
      },
      "& img": {
         height: "100%",
         width: "100%",
      },
      "& .gradientHeading": {
         background:
            "linear-gradient(89deg, #98D9FF 0%, #99E0FA 50%, #9EFFE5 100%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         "& img": {
            height: "50px",
         },
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerHeader": {
            textAlign: "left",
            alignItems: "flex-start",
            "& h2 img": {
               width: "30px",
               height: "30px",
            },
         },
      },
   },
   integrationRightImage: {
      width: "100%",
      "& img": {
         width: "100%",
      },
   },
   tabsSection: {
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${tabsSectionBg})`,
      paddingTop: "300px",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "100%",
         margin: "0 auto",
         textAlign: "center",
      },
      "& $supportBox": {
         position: "absolute",
         top: "-530px",
         "@media only screen and (max-width: 600px)": {
            top: "-800px",
            marginTop: 0,
         },
      },
      "@media only screen and (max-width: 600px)": {
         paddingTop: "150px",
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   tabsContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px",
      border: "2px solid #DBDBDB",
      borderRadius: "40px",
      background: "#fff",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "10px",
         padding: "5px",
         overflow: "auto",
         "&::-webkit-scrollbar": {
            display: "none",
         },
      },
   },
   tab: {
      width: "33%",
      background: "",
      padding: "18px",
      background: "transparent",
      borderRadius: "40px",
      background: "transparent",
      transition: "0.3s ease",
      cursor: "pointer",
      "&.active": {
         color: "white",
         background:
            "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
      },
      "@media only screen and (max-width: 600px)": {
         minWidth: "max-content",
         padding: "10px 15px",
      },
   },
   tabCard: {
      marginTop: "20px",
      gap: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
         marginTop: "30px",
         flexDirection: "column",
      },
   },
   tabCardLeftContainer: {
      width: "50%",
      display: "flex",
      gap: "40px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      "@media only screen and (max-width: 600px)": {
         gap: "20px",
         width: "100%",
      },
   },
   tabCardRightContainer: {
      width: "50%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   benfitListContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "30px",
      marginTop: "50px",
      "@media only screen and (max-width: 600px)": {
         gap: "15px",
         marginTop: "20px",
      },
   },
   benfitListItem: {
      display: "flex",
      width: "100%",
      margin: "0 auto",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "15px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "15px",
         alignItems: "flex-start",
      },
   },
   benfitListItemContent: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "10px",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   absoulteCard: {
      position: "absolute",
      margin: "0 auto",
      width: "100%",
      top: "70%",
      "@media only screen and (max-width: 600px)": {
         top: "85%",
      },
   },
   boostSection: {
      backgroundImage: `url(${boostBg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      paddingBottom: "200px",
      position: "relative",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "90%",
         margin: "0 auto",
         textAlign: "center",
         // marginTop: "70px",
      },
      "& .header": {
         width: "55%",
         display: "flex",
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         textAlign: "left",
         gap: "32px",
      },
      "& $featureContainer": {
         gap: "20px",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
         "& .header": {
            width: "100%",
         },
         paddingBottom: "170px",
      },
   },
   statsContainer: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         gap: "15px",
      },
   },
   statsBox: {
      width: "24%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "16px",
      background:
         "linear-gradient(142deg, rgba(48, 124, 99, 0.50) 0%, rgba(7, 58, 52, 0.50) 100%)",
      borderRadius: "16px",
      padding: "20px",
      height: "260px",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "15px",
         height: "170px",
      },
   },
   statsBoxHeader: {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      alignItems: "baseline",
      gap: "5px",
   },
   statsBoxBody: {
      display: "flex",
      width: "100%",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "5px",
      "& .border": {
         border: "1px solid #FFFDFD40",
      },
      "& ul": {
         paddingLeft: "18px",
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "& ul": {
            paddingLeft: "18px",
         },
         "& li": {
            marginBottom: "10px",
         },
      },
   },
   statsFont: {
      fontSize: "80px",
   },
   accordianTabs: {
      position: "relative",
      paadingBottom: "0",
      "& .headercenterContainer": {
         display: "flex",
         flexDirection: "column",
         alignItems: "center",
         justifyContent: "center",
         marginBottom: "64px",
         gap: "20px",
         textAlign: "center",
         "& h2": {
            width: "80%",
         },
         "& p": {
            width: "70%",
         },
         "@media (max-width:768px)": {
            flexDirection: "column",
            gap: "20px",
            marginBottom: "55px",
            "& h2": {
               width: "100%",
            },
            "& p": {
               width: "100%",
            },
         },
      },
   },
   experienceContainer: {
      backgroundImage: `url(${experienceBg})`,
      position: "relative",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      "& .centerContainer": {
         width: "70%",
         margin: "0 auto",
         textAlign: "center",
         "@media only screen and (max-width: 1024px)": {
            width: "80%",
         },
         "@media only screen and (max-width: 768px)": {
            width: "90%",
         },
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
   },
   experienceInnerContainer: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
      marginTop: "20px",
      gap: "40px",
      "@media only screen and (max-width: 1024px)": {
         gap: "30px",
      },
      "@media only screen and (max-width: 768px)": {
         flexDirection: "column",
         gap: "40px",
         alignItems: "center",
         marginTop: "0",
      },
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         gap: "20px",
         alignItems: "flex-start",
      },
      "@media only screen and (max-width: 480px)": {
         gap: "15px",
      },
   },
   experienceContainerLeft: {
      width: "40%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "16px",
      "& .exp-desc": {
         marginBottom: "24px",
      },
      "& .view-more-link": {
         textDecoration: "underline",
         cursor: "pointer",
         display: "flex",
         alignItems: "center",
         gap: "10px",
         color: "#1D6FB6",
         marginBottom: "20px",
         "& img": {
            display: "inline-block!important",
            width: "16px!important",
            height: "16px",
            marginTop: "3px!important",
            transition: "transform 0.5s ease",
         },
         "&:hover": {
            color: "#010F1D",
            "& img": {
               transform: "translateX(5px)",
            },
         },
      },
      "@media only screen and (max-width: 1024px)": {
         width: "50%",
         gap: "20px",
      },
      "@media only screen and (max-width: 768px)": {
         width: "100%",
         gap: "24px",
         alignItems: "center",
         textAlign: "center",
         "& .exp-desc": {
            marginBottom: "16px",
         },
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         marginTop: "0px",
         alignItems: "flex-start",
         textAlign: "left",
      },
      "@media only screen and (max-width: 480px)": {
         gap: "18px",
      },
   },
   experienceContainerRight: {
      width: "60%",
      minHeight: "450px",
      "& img": {
         width: "100%",
         height: "100%",
      },
      "@media only screen and (max-width: 768px)": {
         // display: "none",
         width: "100%",
         minHeight: "unset",
      },
   },
   faqHeading: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
   },
   header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      "@media only screen and (max-width: 1024px)": {
         gap: "15px",
      },
      "@media only screen and (max-width: 768px)": {
         gap: "12px",
      },
      "@media only screen and (max-width: 600px)": {
         "& h3": {
            textAlign: "left",
         },
         gap: "10px",
      },
      "@media only screen and (max-width: 480px)": {
         gap: "8px",
      },
   },
   downArrow: {
      transition: "0.3s ease",
      "&.active": {
         transform: "rotate(180deg)",
      },
   },
   collapseBody: {
      margin: "0",
      "& img": {
         display: "none",
      },
      "@media only screen and (max-width: 1024px)": {
         margin: "8px 0 0",
      },
      "@media only screen and (max-width: 768px)": {
         margin: "6px 0 0",
         "& img": {
            display: "block",
            width: "100%",
            marginTop: "12px",
         },
      },
      "@media only screen and (max-width: 600px)": {
         "& img": {
            display: "block",
            width: "100%",
            marginTop: "15px",
         },
      },
      "@media only screen and (max-width: 480px)": {
         margin: "5px 0 0",
         "& img": {
            marginTop: "10px",
         },
      },
   },
   body: {
      textAlign: "left",
      margin: "10px 0  ",
      "& img": {
         display: "none",
      },
      "@media only screen and (max-width: 1024px)": {
         margin: "8px 0 0",
      },
      "@media only screen and (max-width: 768px)": {
         margin: "6px 0 0",
         "& img": {
            display: "block",
            width: "100%",
            marginTop: "12px",
         },
      },
      "@media only screen and (max-width: 600px)": {
         "& img": {
            display: "block",
            width: "100%",
            marginTop: "15px",
         },
      },
      "@media only screen and (max-width: 480px)": {
         margin: "5px 0 0",
         "& img": {
            marginTop: "10px",
         },
      },
   },

   faqBoxAccordian: {
      padding: "0 16px",
      backgroundColor: "transparent",
      borderRadius: "16px",
      position: "relative",
      transition: "all 0.3s ease",
      cursor: "pointer",
      "& h3": {
         color: "#0A2035",
         opacity: "0.7",
      },
      "&:after": {
         content: '""',
         position: "absolute",
         left: "0",
         top: "0",
         width: "2px",
         height: "100%",
         background: "rgba(255, 255, 255, 0.20)",
      },
      "&:before": {
         content: '""',
         position: "absolute",
         background:
            "linear-gradient(180deg,rgba(177, 219, 255, 1) 35%, rgba(113, 215, 186, 1) 35%, #fff 20%, rgba(37, 211, 102, 1) 15% )",
         left: "-1px",
         top: "0",
         width: "4px",
         height: "100%",
         transform: "scaleY(0)",
         transformOrigin: "top",
         zIndex: 1,
      },
      "&.active": {
         "& h3": {
            color: "#0A2035",
            opacity: "1",
         },
         "&:before": {
            animation: "growTimer 10s linear forwards", // Same as JS interval
         },
      },
      "& .body": {
         margin: "0",
      },
      "& .exp-desc": {
         margin: "10px 0 16px",
      },
   },
   wpFaq: {
      // paddingTop: "120px",
      "@media only screen and (max-width: 600px)": {
         "& section": {
            padding: "0px 0 0 !important",
         },
      },
   },
   commonPageFooterSection: {
      background:
         "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "80%",
         margin: "0 auto",
         textAlign: "center",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   belowText: {
      width: "100%",
      textAlign: "right",
      color: "#C0FFEB80",
      marginTop: "10px",
   },
   broadcastContainer: {
      backgroundImage: `url(${newSectionBackground})`,
      backgroundPosition: "top",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "78%",
         margin: "0 auto",
         textAlign: "center",
      },
      "& $broadcastRightContainer": {
         width: "40%",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
         "& $broadcastRightContainer": {
            width: "100%",
         },
      },
   },
   workflowBroadcastContainerInner: {
      width: "100%",
      display: "flex",
      position: "relative",
      alignItems: "stretch",
      gap: "30px",
      padding: "0 4rem 4rem !important",
      overflow: "auto",
      justifyContent: "flex-start",
      "&::-webkit-scrollbar": {
         display: "none",
      },
      "@media only screen and (max-width: 600px)": {
         padding: "0 15px 40px !important",
      },
      "@media only screen and (min-width: 1900px)": {
         padding: "0 19rem 6rem !important",
      },
      "& .swiper-wrapper": {
         alignItems: "stretch",
      },
   },
   broadcastBox: {
      display: "flex !important",
      padding: "40px",
      background: "#009249",
      alignItems: "center",
      borderRadius: "20px",
      justifyContent: "space-between",
      minWidth: "70%",
      maxWidth: "70%",
      minHeight: "400px",
      maxHeight: "400px",
      // minHeight: "415px",
      // maxHeight: "415px",
      transition: "0.3s ease",
      overflow: "hidden",
      "&.active": {
         transform: "scale(1) !important",
      },
      "&.inActive": {
         transform: "scale(0.8) !important",
      },
      "@media only screen and (max-width: 600px)": {
         padding: "20px",
         gap: "15px",
         flexDirection: "column",
         minHeight: "600px",
         justifyContent: "space-between",
         minWidth: "90%",
         maxWidth: "90%",
      },
      "@media only screen and (min-width: 1800px)": {
         minWidth: "80%",
         maxWidth: "80%",
      },
   },
   broadcastLeftContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      width: "55%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   broadcastRightContainer: {
      width: "40%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      "& img": {
         width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "& img": {
            width: "100%",
         },
      },
   },
   broadcastImg: {
      "& img": {
         width: "100%",
         position: "relative",
         bottom: "0",
      },
   },
}));

const WhatsappCrmForCustomSupport = () => {
   const classes = useStyles();
   const [activeRealWorld, setActiveRealWorld] = useState(0);
   const [activeAccordian, setActiveAccordian] = useState(0);
   const AUTO_PLAY_INTERVAL = 10000;
   const { ref, inView } = useInView({
      threshold: 0.5, // adjust as needed
      triggerOnce: false,
   });
   const sectionRef = useRef(null);

   const tabContentData = [
      {
         tabContent: [
            {
               content:
                  "Provide instant responses to product availability or specifications.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Send automated order confirmations and delivery updates.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Manage returns and exchange requests with clear ticket tracking.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Share personalised offers or promotions based on purchase history.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content: "Handle payment or checkout issues in real time.",
               alt: "WhatsApp CRM for customer service",
            },
         ],
         img: realWorldImg1,
         alt: "WhatsApp CRM for customer service",
         subtitle:
            "Retailers and online stores deal with high volumes of customer queries daily, from product questions to delivery updates. A WhatsApp CRM helps streamline these interactions and ensures a smoother shopping experience.",
      },
      {
         tabContent: [
            {
               content: "Manage appointment bookings and confirmations.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Send reminders for follow-ups, prescriptions, or check-ups.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Answer common queries about services, timings, or insurance.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Escalate urgent medical enquiries to specialists quickly.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content: "Collect patient feedback for service improvement.",
               alt: "WhatsApp CRM for customer service",
            },
         ],
         img: realWorldImg2,
         alt: "WhatsApp CRM for customer service",
         subtitle:
            "Clinics, hospitals, and wellness centres rely on fast, reliable communication to build patient trust. A WhatsApp CRM improves coordination and ensures timely support for patients.",
      },
      {
         tabContent: [
            {
               content: "Provide admission details and application support.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Share updates on deadlines, schedules, or class changes.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content: "Answer FAQs about courses, fees, or scholarships.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Support students with academic or administrative queries.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content: "Send reminders for events, exams, or parent meetings.",
               alt: "WhatsApp CRM for customer service",
            },
         ],
         img: realWorldImg3,
         alt: "Educational Institutions CRM",
         subtitle:
            "Schools, colleges, and training centres often receive questions from students and parents. A WhatsApp CRM system allows them to respond faster while keeping records organised.",
      },
      {
         tabContent: [
            {
               content:
                  "Share instant booking confirmations and itinerary details.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Provide real-time updates on delays, cancellations, or changes.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Handle rescheduling or cancellation requests efficiently.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Answer questions about services, amenities, or policies.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Collect feedback after trips or stays to improve offerings.",
               alt: "WhatsApp CRM for customer service",
            },
         ],
         img: realWorldImg4,
         alt: "Travel and Hospitality CRM",
         subtitle:
            "From booking confirmations to customer complaints, travel and hospitality businesses must deliver quick responses. A WhatsApp CRM helps maintain trust and enhances customer experience.",
      },
      {
         tabContent: [
            {
               content:
                  "Log client-reported issues as support tickets instantly.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Escalate urgent incidents to the right technical specialist.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Share real-time updates on issue resolution or downtime.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Integrate with tools like Jira or Confluence for task tracking.",
               alt: "WhatsApp CRM for customer service",
            },
            {
               content:
                  "Collect client feedback after ticket closures to improve service quality.",
               alt: "WhatsApp CRM for customer service",
            },
         ],
         img: realWorldImg5,
         alt: "WhatsApp CRM for customer service",
         subtitle:
            "IT companies handle everything from troubleshooting technical issues to ongoing support for clients. A WhatsApp CRM system helps them deliver faster resolutions, improve client satisfaction, and manage service requests more efficiently.",
      },
   ];

   const growingList = [
      {
         icon: growingIcon1,
         background: "#F9F1FF",
         heading: "Engage customers where they are",
         text: "WhatsApp has higher open and response rates than email, so you can connect with customers on the channel they use daily.",
      },
      {
         icon: growingIcon2,
         background: "#F4FAFF",
         heading: "Never lose track of a query",
         text: "Each message becomes a ticket in your CRM, making it easy to assign, prioritise, and resolve without missing anything.",
      },
      {
         icon: growingIcon3,
         background: "#FFF5F1",
         heading: "Get the full picture of every customer",
         text: "With CRM integration, you can view past purchases and interactions, helping you respond with context and clarity.",
      },
      {
         icon: growingIcon4,
         background: "#F9F1FF",
         heading: "Scale without hiring more staff",
         text: "As customer queries grow, a WhatsApp CRM system lets you manage more conversations without needing a bigger team.",
      },
      {
         icon: growingIcon5,
         background: "#FFF5E8",
         heading: "Offer better customer experiences",
         text: "Faster responses and personalised service make customers feel valued, encouraging trust and loyalty.",
      },
   ];
   const capabilities = [
      {
         heading: "AI-powered chatbots",
         desc: "Provide customers with instant answers at any time of the day. AI chatbots reduce agent workload, ensure consistent responses, and improve customer satisfaction with quick first-level support.",
         points: [
            {
               text: "Trained on custom knowledge base",
            },
            {
               text: "Available even during business-off hours",
            },
            {
               text: "Automated chat flows",
            },
         ],
         image: capabilitiesImg1,
         background: "linear-gradient(90deg, #053333 0%, #009A99 100%)",
      },
      {
         heading: "Round-robin ticket assignment",
         desc: "Distribute incoming tickets fairly across agents. This balances workloads, avoids bottlenecks, and ensures customers receive faster responses without long wait times.",
         points: [
            {
               text: "Automated ticket routing",
            },
            {
               text: "Real-time agent availability",
            },
            {
               text: "Equal workload distribution",
            },
         ],
         image: capabilitiesImg2,
         background: "linear-gradient(90deg, #00343E 0%, #028BA6 100%)",
      },
      {
         heading: "SLA tracking and escalation",
         desc: "Meet service commitments by tracking response and closure times. Automatic escalations to managers help maintain accountability and protect service quality.",
         points: [
            {
               text: "Pre-define SLA times",
            },
            {
               text: "Define escalation matrix",
            },
            {
               text: "Auto-escalate tickets",
            },
         ],
         image: capabilitiesImg3,
         background: "linear-gradient(270deg, #2788E7 0%, #5F288C 100%)",
      },
      {
         heading: "Jira/Confluence integration",
         desc: "Convert support tickets into tasks instantly. This integration streamlines collaboration with technical teams and ensures complex issues are resolved without delays.",
         points: [
            {
               text: "Integrated with multiple tools",
            },
            {
               text: "All-in-one platform",
            },
            {
               text: "Auto-create tasks",
            },
         ],
         image: capabilitiesImg4,
         background: "linear-gradient(90deg, #2E1047 0%, #783CA8 100%)",
      },
      {
         heading: "Real-time dashboard",
         desc: "Gain full visibility into support team performance and individual performance. Keep track of analytics and access actionable insights. Monitor SLA compliance, agent efficiency, and ticket trends in real time to make data-driven improvements.",
         points: [
            {
               text: "SLA compliance dashboard",
            },
            {
               text: "Real-time user status overview",
            },
            {
               text: "Analyse issue resolution trends",
            },
         ],
         image: capabilitiesImg5,
         background: "linear-gradient(90deg, #092B48 0%, #2576BB 100%)",
      },
   ];

   const statsBoxContent = [
      {
         number: "86",
         symbol: "%",
         content:
            "of buyers are willing to pay more for a better customer experience",
         color: "#C0FFEB",
      },
      {
         number: "61",
         symbol: "%",
         content:
            "of small businesses report over half their revenue comes from repeat customers",
         color: "#C0FFEB",
      },
      {
         number: "50",
         symbol: "%",
         content: "reduction in agent workload with automated replies",
         color: "#C0FFEB",
      },
      {
         number: "2",
         symbol: "X",
         content:
            "Faster query resolution with quick-replies and predefined FAQs",
         color: "#C0FFEB",
      },
   ];
   const experienceList = [
      {
         title: "Define clear workflows for ticket assignment and escalation",
         alt: "WhatsApp CRM for customer service",
         // img: experienceImg2,
         desc: "A structured workflow ensures that every query is tracked, assigned, and resolved on time. Clear escalation rules prevent delays, while role-based assignments help distribute tasks fairly across the team.",
      },
      {
         title: "Use automation for FAQs and repetitive queries",
         alt: "WhatsApp CRM for customer service",
         // img: experienceImg3,
         desc: "Automating routine responses—such as order status, payment confirmations, or appointment reminders—saves valuable time. This allows support teams to focus their energy on more complex, high-value queries that need personal attention.",
      },
      {
         title: "Monitor analytics to continuously improve service quality",
         alt: "WhatsApp CRM for customer service",
         // img: experienceImg4,
         desc: "Metrics such as response times, resolution rates, and customer satisfaction scores provide visibility into performance. By reviewing these analytics regularly, businesses can identify gaps, improve processes, and train teams where needed.",
      },
      {
         title: "Train agents to use the CRM effectively",
         alt: "WhatsApp CRM for customer service",
         // img: experienceImg5,
         desc: "Technology is only as strong as the people who use it. Providing proper training ensures agents understand how to access customer history, apply sentiment insights, and use collaboration tools for more personalised and efficient responses.",
      },
      {
         title: "Ensure compliance with WhatsApp Business policies",
         alt: "WhatsApp CRM for customer service",
         // img: experienceImg6,
         desc: "Following WhatsApp’s guidelines keeps customer communication secure and prevents service disruptions. Compliance also reassures customers that their data is protected, helping build trust in the brand.",
      },
   ];

   const faqs = [
      {
         question:
            "What are the benefits of WhatsApp ticketing for customer service?",
         answer:
            "It improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
      },
      {
         question:
            "What are the top 3 features which make CRM ideal for customer support on WhatsApp?",
         answer: (
            <ul>
               <li>Smart ticketing system with automation rules.</li>
               <li>Multi-channel inbox with complete customer history.</li>
               <li>Real-time agent availability and assignment.</li>
            </ul>
         ),
      },
      {
         question: "How to choose the best WhatsApp CRM for customer support?",
         answer:
            "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
      },
      {
         question: " How do I set up a WhatsApp ticketing system?",
         answer:
            "Connect your WhatsApp Business number with the Pepper Cloud WhatsApp ticketing system, define assignment and SLA rules, set up an AI chatbot and connect it to your knowledge base, and go live. With Pepper Cloud, setup typically takes less than a day.",
      },
      {
         question: "How secure is customer data in a WhatsApp CRM system?",
         answer:
            "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
      },
      {
         question: "Does WhatsApp CRM integrate with other business tools?",
         answer:
            "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
      },
      {
         question: "How does WhatsApp CRM improve customer retention?",
         answer:
            "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
      },
      {
         question:
            "What role does AI play in WhatsApp CRM for customer support?",
         answer:
            "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
      },
      {
         question:
            "Can multiple agents use one WhatsApp number?",
         answer:
            "Yes. Pepper Cloud connects your WhatsApp Business number to a shared inbox where unlimited agents can view, assign, and resolve conversations simultaneously — without duplicate replies or lost context.",
      },
      {
         question: "How does WhatsApp CRM support omnichannel communication?",
         answer:
            "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
      },
   ];

   useEffect(() => {
      let interval;

      const startAutoplay = () => {
         clearInterval(interval);
         interval = setInterval(() => {
            setActiveAccordian((prev) => (prev + 1) % experienceList.length);
         }, AUTO_PLAY_INTERVAL);
      };

      const observer = new IntersectionObserver(
         (entries) => {
            if (entries[0].isIntersecting) {
               startAutoplay();
            } else {
               clearInterval(interval);
            }
         },
         { threshold: 0.3 },
      );

      if (sectionRef.current) {
         observer.observe(sectionRef.current);
      }

      return () => {
         clearInterval(interval);
         if (sectionRef.current) {
            observer.unobserve(sectionRef.current);
         }
      };
   }, [experienceList.length]);

   // client

   const allIconsclient = [
      {
         img: clientLogo1,
      },
      {
         img: clientLogo2,
      },
      {
         img: clientLogo3,
      },
      {
         img: clientLogo4,
      },
      {
         img: clientLogo5,
      },
      {
         img: clientLogo6,
      },
      {
         img: clientLogo7,
      },
   ];

   // Function to distribute icons across three tracks
   function clientdistributeIcons(icons) {
      // Sort icons alphabetically to ensure consistent distribution
      const sortedIcons = [...icons].sort((a, b) => a.img.localeCompare(b.img));

      const clientlogotrack1 = [];
      const clientlogotrack2 = [];
      const clientlogotrack3 = [];

      sortedIcons.forEach((icon, index) => {
         // Distribute icons based on their index
         switch (index % 3) {
            case 0:
               clientlogotrack1.push(icon);
               break;
            case 1:
               clientlogotrack2.push(icon);
               break;
            case 2:
               clientlogotrack3.push(icon);
               break;
         }
      });

      return {
         clientlogotrack1,
         clientlogotrack2,
         clientlogotrack3,
      };
   }

   // Get the distributed icons
   const { clientlogotrack1, clientlogotrack2, clientlogotrack3 } =
      clientdistributeIcons(allIconsclient);

   useEffect(() => {
      if (typeof window === "undefined") return; // Skip SSR

      class InfiniteScroll {
         constructor(row, speed) {
            this.row = row;
            this.track = row?.querySelector(".logos-track");
            this.speed = speed;
            this.position = 0;
            this.direction = row?.dataset?.direction || "left";
            if (this.track) {
               this.init();
            }
         }

         init() {
            // Clone the content safely
            const content = this.track.innerHTML;
            this.track.innerHTML = content + content + content;

            // Get all logos
            const logos = this.track.querySelectorAll(".logo");
            if (logos.length === 0) return;

            // Calculate total width
            let totalWidth = 0;
            logos.forEach((logo) => {
               const style = getComputedStyle(logo);
               totalWidth +=
                  logo.offsetWidth +
                  parseInt(style.marginLeft) +
                  parseInt(style.marginRight);
            });

            // Set row height
            this.row.style.height = `${logos[0].offsetHeight + 2}px`;

            // Set initial position
            this.position =
               this.direction === "left" ? 0 : -this.track.offsetWidth / 3;

            // Start animation
            this.animate();
         }

         animate() {
            const loop = () => {
               if (!this.track) return;

               if (this.direction === "left") {
                  this.position -= this.speed;
                  if (this.position <= -this.track.offsetWidth / 3) {
                     this.position = 0;
                  }
               } else {
                  this.position += this.speed;
                  if (this.position >= 0) {
                     this.position = -this.track.offsetWidth / 3;
                  }
               }

               this.track.style.transform = `translateX(${this.position}px)`;
               requestAnimationFrame(loop);
            };

            requestAnimationFrame(loop);
         }
      }

      // Wait until DOM is ready and elements are in place
      const rows = document.querySelectorAll(".logos-row");
      if (rows.length > 0) {
         rows.forEach((row) => {
            const speed = parseFloat(row.dataset.speed) || 1;
            new InfiniteScroll(row, speed);
         });
      }
   }, []);

   const [lastScrollY, setLastScrollY] = useState(0);
   const [scrollPosition, setScrollPosition] = useState(0);
   useEffect(() => {
      const handleScroll = () => {
         const currentScrollY = window.scrollY;
         setScrollPosition(currentScrollY);
         if (currentScrollY > lastScrollY && currentScrollY > 100) {
            // setSubMenuOpen(false);
            // setIsVisible(false);
         } else {
            // setSubMenuOpen(false);
            // setIsVisible(true);
         }

         setLastScrollY(currentScrollY);
      };

      window.addEventListener("scroll", handleScroll, { passive: true });
      return () => window.removeEventListener("scroll", handleScroll);
   }, [lastScrollY]);

   // client

   useEffect(() => {
      const cards = document.querySelectorAll(".card");

      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               const card = entry.target;
               const currentIndex = Array.from(cards).indexOf(card);

               if (entry.isIntersecting) {
                  // Remove all previous classes first
                  cards.forEach((c) => {
                     c.classList.remove(
                        "is-previous-1",
                        "is-previous-2",
                        "is-previous-3",
                        "is-previous-4",
                     );
                  });

                  // Add appropriate classes based on distance from current card
                  cards.forEach((c, index) => {
                     if (index < currentIndex) {
                        const difference = currentIndex - index;
                        if (difference <= 4) {
                           // Only apply effects to 4 cards back
                           c.classList.add(`is-previous-${difference}`);
                        }
                     }
                  });
               }
            });
         },
         {
            root: null,
            threshold: 0.5,
            rootMargin: "0px",
         },
      );

      cards.forEach((card) => observer.observe(card));

      return () => observer.disconnect();
   }, []);

   const broadcastList = [
      {
         tag: "Click-to-WhatsApp ads",
         heading: "Generate and convert leads using WhatsApp ads",
         content:
            "Run click-to-WhatsApp ads on Facebook and Instagram to capture leads instantly. Manage incoming chats within your CRM, engage in real-time and convert ad clicks into qualified opportunities, all in one unified workspace.",
         img: broadcastImg1,
         alt: "AI content engine for marketing",
         link: "/whatsapp-crm-features/click-to-whatsApp-ads/",
         background: "linear-gradient(180deg, #06A099 0%, #0A542F 100%)",
      },
      {
         tag: "Chatbot",
         heading: "Automate conversations with AI chatbot",
         content:
            "Enhance customer engagement with real-time, intelligent automation. Let our AI-powered chatbot manage repetitive queries, qualify leads and provide instant 24/7 responses, helping your team close deals 3x faster.",
         img: broadcastImg2,
         alt: "Omnichannel lead capture",
         link: "/whatsapp-crm-features/ai-whatsapp-chatbot/",
         background: "linear-gradient(180deg, #06A099 0%, #0A542F 100%)",
      },
      {
         tag: "Catalog",
         heading: "Showcase products using WhatsApp catalog",
         content:
            "Create and share interactive product catalogues with descriptions, images, and prices. Enable customers to browse, enquire and purchase directly on WhatsApp, transforming casual chats into instant conversions.",
         img: broadcastImg3,
         alt: "Campaign automation workflows",
         link: "/whatsapp-crm-features/best-whatsapp-business-catalogue-for-sales/",
         background: "linear-gradient(180deg, #06A099 0%, #0A542F 100%)",
      },
      {
         tag: "Broadcast",
         heading: "Scale engagement with WhatsApp broadcasts",
         content:
            "Send targeted messages, promotions, and updates to multiple customers simultaneously. Personalise communication, schedule broadcasts, and monitor performance all from within your WhatsApp CRM.",
         img: broadcastImg4,
         alt: "AI insights and summaries",
         link: "/whatsapp-crm-features/best-whatsapp-broadcast-messages-software/",
         background: "linear-gradient(180deg, #06A099 0%, #0A542F 100%)",
      },
   ];

   return (
      <main>
         <SEO
            title={
               "WhatsApp ticketing for customer support | Pepper Cloud"
            }
            pathname={
               "https://peppercloud.com/whatsApp-CRM-for-customer-service"
            }
            keywords=" WhatsApp CRM for customer service, WhatsApp CRM for customer support, customer service on whatsapp, whatsapp for customer service, whatsapp crm for support, Best whatsapp, crm for customer service, CRM for customer service on whatsapp"
            description={
               "Provide customer service on WhatsApp with the best WhatsApp customer support software. Create, assign, escalate, and resolve support tickets quickly."
            }
            ogData={{
               "og:image": [
                  "/meta/og/1X1/home.png",
                  "/meta/og/1024X512/home.png",
                  "/meta/og/1200X630/home.png",
               ],
            }}
            scripts={[
               `gtag('event', 'whatsapp_support_crm_generate_lead', {});`,
            ]}
            jsonLd={[
               {
                  "@context": "https://schema.org",
                  "@type": "Organization",
                  name: "Pepper Cloud",
                  legalName: "Pepper Cloud PTE LTD",
                  url: "https://peppercloud.com/",
                  logo: "https://peppercloud.com/icons/logo.png",
                  foundingDate: "2017",
                  address: [
                     {
                        "@type": "PostalAddress",
                        streetAddress: "#04-01/02",
                        addressLocality: "Blk 79 Ayer Rajah Crescent",
                        addressRegion: "SG",
                        postalCode: "139955",
                        addressCountry: "Singapore",
                     },
                     {
                        "@type": "PostalAddress",
                        streetAddress:
                           "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                        addressLocality: "Bengaluru",
                        addressRegion: "KA",
                        postalCode: "560095",
                        addressCountry: "India",
                     },
                  ],
                  contactPoint: {
                     "@type": "ContactPoint",
                     contactType: "customer support",
                     telephone: "+6566562616",
                     email: [
                        "sales@peppercloud.com",
                        "support@peppercloud.com",
                     ],
                  },
                  sameAs: [
                     "https://twitter.com/peppercloudpte",
                     "https://www.linkedin.com/company/peppercloud/",
                     "https://www.facebook.com/PepperCloudPteLtd",
                     "https://www.instagram.com/pepper.cloud/",
                  ],
               },
               {
                  "@context": "https://schema.org/",
                  "@type": "FAQPage",
                  mainEntity: [
                     {
                        "@type": "Question",
                        name: "What are the benefits of WhatsApp CRM for customer service?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "WhatsApp CRM improves response speed, ensures no query goes unanswered, enables team collaboration, and provides complete visibility into customer interactions. It also helps SMEs scale customer service without increasing staff costs.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "What are the top 3 features which make our CRM ideal for customer support on WhatsApp?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Our CRM offers a smart ticketing system with automation rules, a multi-channel inbox with complete customer history, and real-time agent availability and assignment, making it ideal for customer support on WhatsApp.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How to choose the best WhatsApp CRM for customer support?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "The best WhatsApp CRM should integrate seamlessly with your existing systems, offer automation to handle large volumes, provide detailed analytics, and be easy to use for your support team. For SMEs, it should also be scalable and cost-effective.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Can WhatsApp CRM work for small and medium businesses?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes. WhatsApp CRM is designed to scale with your business. SMEs benefit from automation, ticket management, and customer history features without needing large support teams.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How secure is customer data in a WhatsApp CRM system?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Most WhatsApp CRM systems follow strict compliance with WhatsApp Business API policies and data protection standards. This ensures conversations and customer data remain secure and private.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Does WhatsApp CRM integrate with other business tools?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes. A good WhatsApp CRM integrates with sales CRM, payment gateways, project management tools, and marketing platforms, helping you unify operations across teams.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How does WhatsApp CRM improve customer retention?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "By responding faster, personalising interactions, and keeping track of every customer’s history, WhatsApp CRM helps businesses build stronger relationships, increasing loyalty and repeat business.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "What role does AI play in WhatsApp CRM for customer support?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "AI enhances support by powering chatbots, automating repetitive queries, analysing sentiment, and assisting agents with quick, accurate responses—improving both efficiency and customer experience.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Can multiple team members manage the same customer conversation?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes. With collaboration tools inside WhatsApp CRM, multiple agents can view, comment, and resolve queries together without losing context or duplicating work.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How does WhatsApp CRM support omnichannel communication?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "A WhatsApp CRM combines WhatsApp, email, and other messaging platforms into one inbox, allowing teams to respond consistently across all channels.",
                        },
                     },
                  ],
               },
            ]}
         />
         <section className={classes.whatsappSection}>
            <div className="container">
               <div className={classes.aiSectionContainer}>
                  <div className={classes.aiSectionLeft}>
                     <motion.h1
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-64 color-white"
                     >
                        Best{" "}
                        <img
                           src={whatsappHeroIcon}
                           className="wpLogo"
                           alt="WhatsApp CRM for customer service"
                        />{" "}
                        WhatsApp CRM for{" "}
                        <span className="countryHighlight">
                           customer service
                        </span>
                     </motion.h1>
                     <motion.p
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-white"
                     >
                        Pepper Cloud is an AI-powered WhatsApp CRM that turns
                        every WhatsApp message into a trackable support ticket.
                        Respond instantly with AI chatbots, route issues
                        automatically to the right agents, and manage all
                        customer conversations from one shared team inbox — on a
                        single WhatsApp Business number.
                     </motion.p>
                     <div className={classes.listContainer}>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.listItem}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              alt={"WhatsApp CRM for customer service"}
                              className={classes.pointerImg}
                           />
                           <p className="font-wix-regular font-18">
                              AI-powered automation
                           </p>
                        </motion.div>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.listItem}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              alt={"WhatsApp CRM for customer service"}
                              className={classes.pointerImg}
                           />
                           <p className="font-wix-regular font-18">
                              WhatsApp integration
                           </p>
                        </motion.div>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.listItem}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              alt={"WhatsApp CRM for customer service"}
                              className={classes.pointerImg}
                           />
                           <p className="font-wix-regular font-18">
                              Faster issue resolution
                           </p>
                        </motion.div>
                     </div>
                     <div className="buttonContaienr">
                        <Link
                           className="primaryButton font-16 font-wix-medium font-white"
                           to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                        >
                           Book a free demo
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.Client}>
            <div className="container">
               <div className={classes.clientDetails}>
                  <div className="header">
                     <motion.h2
                        className="font-wix-semibold font-56 colorWhite"
                        initial={{ opacity: 1, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                     >
                        Trusted by businesses across industries
                     </motion.h2>
                  </div>
                  <div className="client-carousel lightGreen">
                     <div className="logos-container">
                        <div className="scroll-container">
                           <div
                              className="logos-row"
                              data-direction="left"
                              data-speed="0.8"
                           >
                              <div className="logos-track">
                                 {clientlogotrack1.map((logo) => (
                                    <div
                                       className="logo font-18 font-wix-medium"
                                       key={logo.title}
                                    >
                                       <img
                                          alt={`${logo.title} integration`}
                                          src={logo.img}
                                       />
                                       <p>{logo.title}</p>
                                    </div>
                                 ))}
                              </div>
                           </div>

                           <div
                              className="logos-row"
                              data-direction="right"
                              data-speed="0.4"
                           >
                              <div className="logos-track">
                                 {clientlogotrack2.map((logo) => (
                                    <div className="logo font-18 font-wix-medium">
                                       <img
                                          alt={`${logo.title} integration`}
                                          src={logo.img}
                                       />
                                       <p>{logo.title}</p>
                                    </div>
                                 ))}
                              </div>
                           </div>

                           <div
                              className="logos-row"
                              data-direction="left"
                              data-speed="0.8"
                           >
                              <div className="logos-track">
                                 {clientlogotrack3.map((logo) => (
                                    <div className="logo font-18 font-wix-medium">
                                       <img
                                          alt={`${logo.title} integration`}
                                          src={logo.img}
                                       />
                                       <p>{logo.title}</p>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className={clsx(classes.benefitSection)}>
            <div className="container">
               <div className={classes.integrationHeader}>
                  <div className={classes.integrationRight}>
                     <LazyImage
                        source={benifitImage1}
                        alt={"WhatsApp CRM for customer service"}
                        className={classes.integrationRightImage}
                     />
                  </div>
                  <div className={classes.integrationLeft}>
                     <motion.h2
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-56 font-white"
                     >
                       What is WhatsApp ticketing system?
                     </motion.h2>
                     <motion.p
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-white mt20"
                     >
                       A WhatsApp ticketing system (also known as a WhatsApp helpdesk) is software that automatically converts incoming WhatsApp messages into support tickets. With WhatsApp helpdesk, you can create tickets from individual and WhatsApp Group conversations, route them to the right agents, and ensure no customer request goes unanswered.
                     </motion.p>
                     <div className={clsx(classes.pointers, "mt30")}>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.cardPointer}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              className={classes.pointerImg}
                              alt={"WhatsApp CRM for customer service"}
                           />
                           <p className="font-wix-regular font-18 font-white">
                              <span>For agents: </span> Access the right
                              customer information at the right time, with
                              AI-powered suggestions and full conversation
                              history to resolve queries faster.
                           </p>
                        </motion.div>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.cardPointer}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              className={classes.pointerImg}
                              alt={"WhatsApp CRM for customer service"}
                           />
                           <p className="font-wix-regular font-18 font-white">
                              <span>For leaders: </span> Track team performance,
                              monitor service quality, and ensure accountability
                              with smart dashboards and reporting.
                           </p>
                        </motion.div>
                        <motion.div
                           initial={{ opacity: 1, y: 20 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.3 }}
                           className={classes.cardPointer}
                        >
                           <LazyImage
                              source={greenCheckCircle}
                              className={classes.pointerImg}
                              alt={"WhatsApp CRM for customer service"}
                           />
                           <p className="font-wix-regular font-18 font-white">
                              <span>For customers: </span> Get quick, seamless,
                              and personalised support on the channel they use
                              most, without delays or repeated explanations.
                           </p>
                        </motion.div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.growingBusiness}>
            <div className="container">
               <div className="header">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-medium font-56 font-black1"
                  >
                     Why do businesses need WhatsApp CRM for customer service?
                  </motion.h2>
                  <motion.p
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-regular font-18 font-black1"
                  >
                     WhatsApp CRM for customer support brings all the support
                     conversations into one place, so you can stay organised,
                     respond faster, and deliver the kind of service that keeps
                     customers coming back.
                  </motion.p>
               </div>
            </div>
            <Swiper
               slidesPerView={3.3}
               // centeredSlides={true}
               spaceBetween={30}
               grabCursor={true}
               loop={false}
               speed={5000}
               modules={[Autoplay]}
               autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
               }}
               // freeMode={true}
               className={classes.broadcastContainerInner}
               breakpoints={{
                  // For smaller screens (mobile)
                  0: {
                     slidesPerView: 1.3,
                     slidesPerGroup: 1,
                     freeMode: true,
                     grabCursor: false,
                     allowTouchMove: true,
                     spaceBetween: 10,
                  },
                  // For larger screens (desktop)
                  768: {
                     slidesPerView: 3.3,
                     centeredSlides: false,
                     spaceBetween: 30,
                     grabCursor: true,
                  },
               }}
            >
               {growingList.map((feature) => (
                  <SwiperSlide
                     className={classes.featureContainer}
                     //   style={{ background: feature.background }}
                  >
                     <LazyImage
                        source={feature.icon}
                        alt={"WhatsApp CRM for customer service"}
                        className={classes.featureIcon}
                        // alt={listItem.alt}
                     />
                     <p className="font-wix-semibold font-24 color-black1">
                        {feature.heading}
                     </p>
                     <p className="font-wix-mediu font-18 color-black1">
                        {feature.text}
                     </p>
                  </SwiperSlide>
               ))}
            </Swiper>
            {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
         </section>
         <section className={classes.cardsSection}>
            <div className="container">
               <div className="centerHeader">
                  {/* <p className="font-18 font-wix-semibold font-white">Features</p> */}
                  <motion.h2
                     initial={{ opacity: 1, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     className="font-wix-medium font-56 font-black1"
                  >
                     Features that solve your customer service challenges
                     {/* <img src={glareIcon} alt={"AI automation"} /> capabilities */}
                  </motion.h2>
               </div>
               <ul id="cards">
                  {capabilities.map((data, index) => (
                     <li className="card" id={`card-${index + 1}`}>
                        <div
                           className="card-content"
                           style={{ background: data.background }}
                        >
                           <div className="cardContentData">
                              <h3 className="cardHeading font-wix-medium">
                                 {data.heading}
                              </h3>
                              <p className="cardDesciption">{data.desc}</p>
                              <div className="cardList">
                                 {data.points.map((point, j) => (
                                    <div className="listItem">
                                       <LazyImage
                                          source={whiteCheckIcon}
                                          alt={
                                             "WhatsApp CRM for customer service"
                                          }
                                       />
                                       <p>{point.text}</p>
                                    </div>
                                 ))}
                              </div>
                           </div>
                           <div className="cardImg">
                              <LazyImage
                                 source={data.image}
                                 alt="WhatsApp CRM for customer service"
                              />
                           </div>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </section>
         <section className={classes.broadcastContainer}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-semibold font-56 font-white"
                  >
                     Maximise growth with WhatsApp sales CRM features
                  </motion.h2>
               </div>
            </div>
            <Swiper
               slidesPerView={1}
               centeredSlides={true}
               modules={[Autoplay]}
               speed={5000}
               autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
               }}
               spaceBetween={30}
               grabCursor={true}
               className={classes.workflowBroadcastContainerInner}
               breakpoints={{
                  // For smaller screens (mobile)
                  0: {
                     slidesPerView: "auto",
                     freeMode: true,
                     grabCursor: false,
                     allowTouchMove: true,
                     spaceBetween: 10,
                     centeredSlides: false,
                  },
                  // For larger screens (desktop)
                  768: {
                     slidesPerView: "auto",
                     centeredSlides: true,
                     spaceBetween: 30,
                     grabCursor: true,
                  },
               }}
            >
               {broadcastList.map((point, index) => (
                  <SwiperSlide
                     className={classes.broadcastBox}
                     style={{ background: point.background }}
                  >
                     <div className={classes.broadcastLeftContainer}>
                        <p className="font-18 font-wix-medium font-white">
                           {point.tag}
                        </p>
                        <p className="font-40 font-wix-medium font-white mt5">
                           {point.heading}
                        </p>
                        <p className="font-18 font-wix-medium font-white mt10">
                           {point.content}
                        </p>
                        <a
                           className="loginButton font-wix-medium font-16 mt20"
                           href={point.link}
                        >
                           Know more
                        </a>
                     </div>
                     <div className={classes.broadcastRightContainer}>
                        <img
                           src={point.img}
                           alt={point.alt}
                           className={classes.broadcastImg}
                        />
                     </div>
                  </SwiperSlide>
               ))}
            </Swiper>
         </section>
         <section className={clsx(classes.benefitSection, "benefitSection2")}>
            <div className="container">
               <div className={classes.integrationHeader}>
                  <div className={classes.integrationLeft}>
                     <motion.div
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="sectionTag"
                     >
                        <p className="font-18  font-wix-semibold color-blue1">
                           Integration
                        </p>
                     </motion.div>
                     <motion.h2
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-56 font-black1"
                     >
                        Completely connected to your business
                     </motion.h2>
                     <motion.p
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-black1 mt20"
                     >
                        Create a unified powerhouse for your sales and support
                        operations by integrating the best CRM system with the
                        popular tools. Connect email inbox, communication
                        channels, accounting software, calling software, and
                        more.
                     </motion.p>
                  </div>
                  <div className={classes.integrationRight}>
                     <LazyImage
                        source={benifitImage2}
                        alt={"WhatsApp CRM for customer service"}
                        className={classes.integrationRightImage}
                     />
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.boostSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-medium font-56 font-white"
                  >
                     Boost customer service and retention with powerful CRM
                     software
                  </motion.h2>
               </div>
               <div className={classes.statsContainer}>
                  {statsBoxContent.map((stat, index) => (
                     <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: index * 0.1 }}
                        className={classes.statsBox}
                     >
                        <div className={classes.statsBoxHeader}>
                           <p
                              style={{ color: `${stat.color}` }}
                              className={clsx(
                                 classes.statsFonts,
                                 "font-72",
                                 "font-wix-medium",
                              )}
                           >
                              {stat.number}
                              <span className="font-48">{stat.symbol}</span>
                           </p>
                           <LazyImage
                              source={greenUpArrowIcon}
                              alt={"WhatsApp CRM for customer service"}
                           />
                        </div>
                        <div className={classes.statsBoxBody}>
                           {/* <div className="border" /> */}

                           <p className="font-18 font-white font-wix-regular">
                              {stat.content}
                           </p>
                        </div>
                     </motion.div>
                  ))}
               </div>
               <div className={classes.belowText}>
                  <p className="font-12 font-wix-regular">
                     * Statistics from multiple sources
                  </p>
               </div>
            </div>

            <div className={classes.absoulteCard}>
               <TruestedSection background={true} />
            </div>
         </section>
         <section className={classes.tabsSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-semibold font-56 color-black1"
                  >
                     Application and use cases of CRM for customer support teams
                  </motion.h2>
                  <div className={classes.tabsContainer}>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 0 && "active",
                        )}
                        onClick={() => setActiveRealWorld(0)}
                     >
                        E-commerce
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 1 && "active",
                        )}
                        onClick={() => setActiveRealWorld(1)}
                     >
                        Healthcare
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 2 && "active",
                        )}
                        onClick={() => setActiveRealWorld(2)}
                     >
                        Education
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 3 && "active",
                        )}
                        onClick={() => setActiveRealWorld(3)}
                     >
                        Travel and hospitality
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 4 && "active",
                        )}
                        onClick={() => setActiveRealWorld(4)}
                     >
                        IT service providers
                     </div>
                  </div>
               </div>
               <div className={classes.tabCard}>
                  <div className={classes.tabCardLeftContainer}>
                     {tabContentData.map(
                        (listItem, index) =>
                           index === activeRealWorld && (
                              <div>
                                 <motion.p
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="font-wix-regular font-18 font-black1"
                                 >
                                    {listItem.subtitle}
                                 </motion.p>
                                 <div className={classes.benfitListContainer}>
                                    {listItem.tabContent.map((item) => (
                                       <motion.div
                                          initial={{ opacity: 0, x: -20 }}
                                          whileInView={{ opacity: 1, x: 0 }}
                                          transition={{ duration: 0.3 }}
                                          className={classes.benfitListItem}
                                       >
                                          <LazyImage
                                             source={greenCheckCircle}
                                             className={classes.benfitIcon}
                                             alt={item.alt}
                                          />
                                          <div
                                             className={
                                                classes.benfitListItemContent
                                             }
                                          >
                                             <p className="font-wix-regular font-18 font-black1">
                                                {item.content}
                                             </p>
                                          </div>
                                       </motion.div>
                                    ))}
                                 </div>
                              </div>
                           ),
                     )}
                  </div>
                  <div className={classes.tabCardRightContainer}>
                     {tabContentData.map(
                        (listItem, index) =>
                           index === activeRealWorld && (
                              <motion.div
                                 initial={{ opacity: 1, y: 20 }}
                                 whileInView={{ opacity: 1, y: 0 }}
                                 transition={{ duration: 0.3 }}
                                 // className={classes.aiSectionRight}
                              >
                                 <LazyImage
                                    source={listItem.img}
                                    alt={listItem.alt}
                                    width={"100%"}
                                 />
                              </motion.div>
                           ),
                     )}
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.experienceContainer} ref={ref}>
            <section className={classes.accordianTabs}>
               <div className="container">
                  <div className="headercenterContainer">
                     <motion.h2
                        className="font-wix-semibold font-56 font-white"
                        initial={{ opacity: 1, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                     >
                        WhatsApp support CRM system: Best practices
                     </motion.h2>
                     <p className="font-18 font-wix-regular font-white">
                        To maximise the benefits of a WhatsApp support CRM
                        system, businesses should follow proven practices that
                        keep operations efficient and customer-focused.
                     </p>
                  </div>
                  <div className={classes.experienceInnerContainer}>
                     <div className={classes.experienceContainerRight}>
                        <motion.img
                           style={{ width: "100%", height: "100%" }}
                           initial={{ opacity: 1, y: 20 }}
                           src={experienceImg}
                           alt="WhatsApp CRM for customer service"
                           transition={{ duration: 0.3 }}
                           whileInView={{ opacity: 1, y: 0 }}
                        />
                     </div>
                     <div
                        className={classes.experienceContainerLeft}
                        ref={sectionRef}
                     >
                        {experienceList.map((faq, index) => (
                           <motion.div
                              className={clsx(
                                 classes.faqBoxAccordian,
                                 index === activeAccordian && "active",
                                 "text-color2",
                              )}
                              key={`faq-${index}-${activeAccordian === index}`}
                              onClick={() => setActiveAccordian(index)}
                              transition={{ duration: 1, delay: index * 0.01 }}
                              whileInView={{ opacity: [0, 1], y: [50, 0] }}
                           >
                              <div className={classes.experienceHeader}>
                                 <h3 className="font-20 font-white font-wix-semibold">
                                    {faq.title}
                                 </h3>
                              </div>
                              <Collapse
                                 className={classes.collapseBody}
                                 in={activeAccordian === index}
                              >
                                 <p className="font-18 font-wix-regular font-white exp-desc">
                                    {faq.desc}
                                 </p>

                                 {/* <motion.img
                        alt={faq.alt}
                        initial={{ opacity: 1, y: 20 }}
                        src={experienceImg}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      /> */}
                              </Collapse>
                           </motion.div>
                        ))}
                     </div>
                  </div>
               </div>
            </section>
         </section>
         <div className={classes.wpFaq}>
            <FaqSection
               backgroundColor={"#FFFFFF"}
               heading={
                  "WhatsApp support CRM - Frequently asked questions (FAQs)"
               }
               faqs={faqs}
            />
         </div>
         <section className={classes.commonPageFooterSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     className="font-wix-medium font-56 font-white"
                  >
                     Best WhatsApp CRM for customer service
                  </motion.h2>
                  <Link
                     className="primaryButton font-20 font-wix-medium font-white"
                     to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                  >
                     Get started
                  </Link>
               </div>
            </div>
         </section>
      </main>
   );
};

export default WhatsappCrmForCustomSupport;
